import PrivacyPolicyApp from 'apps/PrivacyPolicy'
import { simplicityPrivacyContent } from 'vars'
import commonMessages from 'lang/es/common'
import { getCommonStaticProps } from 'commonPage'

export default PrivacyPolicyApp

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()

  return {
    props: {
      titleMeta: 'PRIVACY_TITLE',
      descriptionMeta: 'PRIVACY_DESCRIPTION',
      simplicityPrivacyContent,
      messages: commonMessages,
      ...commonStaticProps,
    },
  }
}
